import { createEffect, Store } from 'effector';
import { NgApiClient } from '@src/api/ngApiClient';
import { ICompany } from '@src/models/company';
import { AccountClientManager } from '@src/utils/accountClient';
import { $companyStore as globalCompanyStore } from '@centra/ui-global-context';

const fetchCompanyDataFx = createEffect(async ({ ngApiClient }: { ngApiClient: NgApiClient }) => {
  return (await ngApiClient
    .get('client', {
      selector: {
        fields: ['name', 'id', 'currentTariffId'],
        predicates: [
          { field: 'kind', operator: 'IN', values: ['advertiser', 'agency'] },
          {
            field: 'archived',
            operator: 'IN',
            values: [true, false],
          },
        ],
      },
    })
    .then((res) => {
      const entries = res?.data?.page?.entries;

      /** Для внутренних ролей количество клиентов пользователей будет больше одного */
      if (entries?.length > 1) {
        return { name: '', id: null, currentTariffId: null } as ICompany;
      } else {
        return entries[0];
      }
    })) as ICompany;
});

/** Unknown нужен для того, чтобы переопределить типы глобального стора, в котором отсутствуют свойства id и currentTariffId */
const $companyStore = (globalCompanyStore as unknown as Store<ICompany>).on(
  fetchCompanyDataFx.doneData,
  (store, update) => {
    /** Обновляем значение текущей компании */
    AccountClientManager.updateActiveCompany(update.name);

    return { ...store, ...update };
  },
);

export const companyEffectorModel = {
  $companyStore,
  fetchCompanyDataFx,
};
